import React from 'react';
import {Layout} from 'antd';

import styles from './Footer.module.scss';
import Icon from '../Icon/Icon';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useUserStore } from '../../store/useUser';
import { navigateToClub } from '../../utils/club';
import { useSidebarStore } from '../../store/useSidebar';
import Button from '../Button/Button';

const { Footer } = Layout;

const itemsNotAuthenticated = (navigate) => [
  <Button style={styles.button} onClick={() => navigate('/login')} >
    Entrar
  </Button>,
  <Button style={styles.button} onClick={() => navigate('/register')} >
    Registrar
  </Button>,
]

const itemsAuthenticated = (navigate, profile, userId, toggle, club?, ) => [
  <Icon
    className={styles.icon}
    icon='three-line'
    onClick={toggle} />,
  <Icon
    className={styles.icon}
    icon='home'
    onClick={() => {
      if (profile === 'Clubista') navigate(`/user/${userId}`)
      else navigate(navigateToClub(club?.name, club?.id))
    }} />,
  <Icon className={styles.icon} icon='lupa-book' onClick={() => navigate('/book')} />,
  <Icon className={styles.icon} icon='lupa' onClick={() => navigate('/club')}/>,
  <Icon className={styles.icon} icon='config'
    onClick={() => {
      if (profile === 'Clubista') navigate('/user/config')
      else navigate('/club/edit')
    }} />
]

const CustomFooter= () => {
  const { pathname } = useLocation() as any;
  const navigate = useNavigate();

  const userId = useUserStore(state => state.id)
  const profile = useUserStore(state => state.profile)
  const club = useUserStore(state => state.club)
  const toggle = useSidebarStore(state => state.toggle)
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' })
  const uiVersion = process.env.REACT_APP_UI_VERSION || "unknown";

  let items;

  if (userId && profile) items = itemsAuthenticated(navigate, profile, userId, toggle, club)
  else items = itemsNotAuthenticated(navigate)

  if(!isMobile && userId && profile) {
    return (
      <Footer className={styles.container}>
        <div className={styles.versionText}>
          {uiVersion}
        </div>
      </Footer>
    )
  }

  if(!isMobile && !userId && !profile) {
    return <></>
  }

  return (
    <Footer className={styles.container}>
      <ul className={styles.menuItems} >
        {items.map((item, index) => <li key={`footer-key-${index}`}>{item}</li>)}
      </ul>
    </Footer>
  )
}

export default CustomFooter;